import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";

export default function Legal() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/public/legal/${slug}`).then((r) => setPage(r.data)).catch(() => setErr(true));
  }, [slug]);

  if (err) return (
    <div className="py-32 text-center">
      <h2 className="font-serif text-4xl text-atelier-text">Page introuvable</h2>
    </div>
  );
  if (!page) return <div className="py-32 text-center text-atelier-textDim">Chargement…</div>;

  return (
    <div className="bg-atelier py-20 lg:py-28">
      <div className="max-w-[820px] mx-auto px-5 lg:px-10">
        <div className="label-tech text-atelier-ink mb-4">— Information légale</div>
        <h1 className="font-serif text-4xl lg:text-6xl mb-12 text-atelier-text">{page.title}</h1>
        <article
          className="prose prose-invert max-w-none prose-headings:font-serif prose-headings:text-atelier-text prose-p:text-atelier-textDim prose-p:font-serif prose-strong:text-atelier-text prose-a:text-atelier-ink"
          dangerouslySetInnerHTML={{ __html: page.content }}
        />
      </div>
    </div>
  );
}
